export default {
      id: "mmenu-arrow-usage",
      viewBox: "0 0 9 16",
      url: __webpack_public_path__ + "app/svg/sprite.svg#mmenu-arrow",
      toString: function () {
        return this.url;
      }
    }